import BaseAPI from '../base'

function getList(cafe_id) {
    return BaseAPI.get(`reviews/list/${cafe_id}`);
}

export default {
    getList
}